import moment from 'moment-timezone';

const instance = moment;
instance.tz.setDefault('Etc/UTC');

export default instance;